import { createSelector } from 'reselect';

const selectEProcurements = (state: any) => state.eProcurements;

export const selectEProcurementsCurrentItem = createSelector([selectEProcurements], (eProcurements) => eProcurements.current);

export const selectEProcurementsListItems = createSelector([selectEProcurements], (eProcurements) => eProcurements.list);


export const selectEProcurementsItemById = (itemId: any) =>
    createSelector(selectEProcurementsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEProcurementsCreatedItem = createSelector([selectEProcurements], (eProcurements) => eProcurements.create);

export const selectEProcurementsQueryItems = createSelector([selectEProcurements], (eProcurements) => eProcurements.query);

export const selectEProcurementsUpdatedItem = createSelector([selectEProcurements], (eProcurements) => eProcurements.update);

export const selectEProcurementsReadItem = createSelector([selectEProcurements], (eProcurements) => eProcurements.read);

export const selectEProcurementsDeletedItem = createSelector([selectEProcurements], (eProcurements) => eProcurements.delete);

export const selectEProcurementsSearchedItems = createSelector([selectEProcurements], (eProcurements) => eProcurements.search);

export const selectEProcurementsItemsCount = createSelector([selectEProcurements], (eProcurements) => eProcurements.count);

export const selectEProcurementsItemsFilter = createSelector([selectEProcurements], (eProcurements) => eProcurements.filter);